//Page Components
import Support from "../components/SupportPage";

const SupportPage = () => {
  return (
    <div>
      <Support />
    </div>
  );
};

export default SupportPage;
